import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { CssBaseline, ThemeProvider } from '@material-ui/core'
import { theme } from 'config/constants/theme/theme'
import { Router, Location } from '@reach/router'
import { Alert } from 'components'
import Routes from './config/Routes'
import { SessionManager } from './smart-components'
import EventPageViewRegister from './smart-components/page-view-register/Provider'

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Alert>
      <React.Fragment>
        <SessionManager>
          <Location>
            {({ location }) => {
              return (
                <EventPageViewRegister location={location.href}>
                  <Router location={location}>
                    {Routes.map(({ id, path, component: Component }) => {
                      return <Component key={id} routeId={id} path={path} />
                    })}
                  </Router>
                </EventPageViewRegister>
              )
            }}
          </Location>
        </SessionManager>
      </React.Fragment>
    </Alert>
  </ThemeProvider>,
  document.getElementById('root')
)
